"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("../sports/football/Facts");
const Facts_2 = require("../sports/rugbyLeague/Facts");
const Facts_3 = require("./Facts");
const Facts_4 = require("../sports/rugbyUnion/Facts");
exports.factNameMap = Object.assign(Object.assign(Object.assign(Object.assign({}, Facts_1.footballFactNameMap), Facts_3.sharedFactNameMap), Facts_2.rugbyLeagueFactNameMap), Facts_4.rugbyUnionFactNameMap);
//# sourceMappingURL=FactNames.js.map